import React from 'react'
import moment from 'moment';
import { CURRENCY, FORMAT_NUMBER, SYMBOL } from "../../libs/utils/Const";
import { development } from "../../libs/utils/Const";




class OrderDoc extends React.Component {

    ExtraTable(DocLines, countLines2, linesfullPage, linesfirstPage, countPages, folio, countComments, nextFolio){
        
        return(
            <table><tr><td>
                <div className='mt-5' style={{height :"auto", width:"90%", marginLeft: "auto", marginRight:"auto"}}>
                    <div className='text-right' style={{fontSize:"14px"}}>
                        <table>
                            <tbody>
                                <tr>
                                    <td className='text-left'>
                                        {folio}
                                    </td>
                                    <td className='text-right'>
                                        {nextFolio + " - "} Pagina {countPages+2}/{Math.trunc((DocLines.length - linesfirstPage) / linesfullPage)+2}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        
                    </div>
                        
                    <div className='row mt-1' style={{ paddingRight: "15px", paddingLeft: "15px" }}>
                        <table>
                            <thead style={{ borderTop: "solid 3px", borderBottom: "solid 3px" }}>
                                <tr>
                                    <th className='pl-5'>Cantidad</th>
                                    <th>m2</th>
                                    <th>Descripción</th>
                                    <th>Descuento % </th>
                                    <th>Precio m2</th>
                                    <th>Precio</th>
                                    <th>Importe</th>
                                </tr>
                            </thead>

                            <tbody style={{ borderBottom: "solid 3px" }}>
                                {DocLines && DocLines.length > 0 &&
                                    DocLines.map((docline, index) => {
                                        
                                        if ((countLines2 > linesfirstPage + (linesfullPage * countPages)) &&  (countLines2  < linesfirstPage  + (linesfullPage * (countPages+1)))) {
                                            countLines2++
                                            if (docline.U_FMB_LineComment != "") {
                                                countComments++
                                            }
                                            return (
                                                <>
                                                    <tr>
                                                        <td className='pl-5'>{Number(docline.Quantity).toFixed(2) ?? ''}</td>
                                                        <td>0.00</td>
                                                        <td>{docline.Dscription ?? ''}</td>
                                                        <td>{Number(docline.DiscPrcnt).toFixed(2) ?? ''}</td>
                                                        <td>0.00</td>
                                                        <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(docline.Price) ?? ''}</td>
                                                        <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(docline.Quantity * docline.Price) ?? ''}</td>
                                                    </tr>
                                                    {docline.U_FMB_LineComment != ""?
                                                        <tr>
                                                            <td ></td>
                                                            <td colSpan={5}><strong>Comentario: </strong>{docline.U_FMB_LineComment}</td>
                                                        </tr>
                                                        :""
                                                    }
                                                </>
                                            );
                                        }else{
                                            countLines2++
                                            return(<></>);
                                        }
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </td></tr></table>
        );
        
    }

    CountCommentsLine(){
        const {DocLines} = this.props
        let numComments=0;
        if (DocLines && DocLines.length > 0 ){
            for (let index = 0; index < DocLines.length; index++) {
                if (DocLines[index].U_FMB_LineComment != "") {
                    numComments++
                }
            }
        }
        return(numComments);
    }


    render(){
        const {DocLines, DocHeader, InfoByFolio, reprint, user, time } = this.props
        let commentsLine = this.CountCommentsLine();
        let linesForAllInOne =25;
        let linesfirstPage = 37;
        let linesfullPage = 50;
        let remainingLines = (DocLines.length-linesfirstPage) - (linesfullPage * Math.trunc((DocLines.length-linesfirstPage)/linesfullPage));
        let totalPages = Math.ceil( (DocLines.length - linesfirstPage) / linesfullPage );
        let countLines = 1;
        let countComments = 0;
        let countLines2 = 1;
        let extraTables = [];
        for (let index = 0; index < totalPages; index++) {
            extraTables.push (this.ExtraTable(DocLines, countLines2, linesfullPage, linesfirstPage, index, InfoByFolio.folio, countComments, (!!InfoByFolio.nextFolio? InfoByFolio.nextFolio : "")))
        }

        if (DocHeader?.U_RS_TIPOV === 'ENVASA') {
            return (
                (DocLines.length + commentsLine) <= linesForAllInOne && (
                    <div className='mt-5' style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto" }}>
                        <div style={{ backgroundColor: 'white', padding: '10px' }}>
                            <div style={{ textAlign: 'center', padding: '10px' }}>
                                <h1 style={{ fontSize: '25px', fontWeight: 'bold', color: '#1E3A8A', margin: 0 }}>ORDEN DE VENTA</h1>
                                <span style={{ fontSize: '15px', color: '#4B5563' }}>Control de entrega y recepción de cilindros</span>
                            </div>
                            <div style={{ backgroundColor: '#1D4ED8', color: 'white', padding: '8px', fontWeight: 'bold', fontSize: '12px' }}>
                                DATOS DE LA ORDEN
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', padding: '10px' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <label style={{ whiteSpace: 'nowrap', fontSize: '12px' }}>Orden de venta N° (por sucursal / DocEntry):</label>
                                        <div style={{ borderBottom: '1px solid #9CA3AF', flex: 1, marginLeft: '8px', fontSize: '12px' }}>{DocHeader?.DocNum} / {DocHeader?.DocEntry}</div>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <label style={{ whiteSpace: 'nowrap' }}>Fecha del documento:</label>
                                        <div style={{ borderBottom: '1px solid #9CA3AF', flex: 1, marginLeft: '8px', fontSize: '12px' }}>{InfoByFolio?.docDate?.substring(0, 10)}</div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <label style={{ whiteSpace: 'nowrap', fontSize: '12px' }}>Unidad asignada:</label>
                                        <div style={{ borderBottom: '1px solid #9CA3AF', flex: 1, marginLeft: '8px', fontSize: '12px' }}></div>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <label style={{ whiteSpace: 'nowrap', fontSize: '12px' }}>Fecha de entrega:</label>
                                        <div style={{ borderBottom: '1px solid #9CA3AF', flex: 1, marginLeft: '8px', fontSize: '12px' }}>{DocHeader?.DocDueDate?.substring(0, 10)}</div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ backgroundColor: '#1D4ED8', color: 'white', padding: '8px', fontWeight: 'bold', fontSize: '12px' }}>
                                DETALLE DE ARTÍCULOS
                            </div>
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#DBEAFE', borderTop: '2px solid #9CA3AF', borderBottom: '2px solid #9CA3AF' }}>
                                            <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px', fontWeight: '600' }}>Descripción de artículos</th>
                                            <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px', fontWeight: '600' }}>Cantidad</th>
                                            <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px', fontWeight: '600' }}>Entrega cilindros</th>
                                            <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px', fontWeight: '600' }}>Tipo de convenio</th>
                                            <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px', fontWeight: '600' }}>Cant. cilindros que entrega</th>
                                            <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px', fontWeight: '600' }}>Cant. cilindros físicos (en buenas condiciones)</th>
                                            <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px', fontWeight: '600' }}>Cantidad atendida</th>
                                        </tr>
                                    </thead>
                                    {DocLines && DocLines.length > 0 && (
                                        <tbody>
                                            {DocLines.map((docline, index) => (
                                                <tr key={docline.LineNum || index}>
                                                    <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px', fontSize: '12px' }}>
                                                        {docline?.Dscription || '-'}
                                                    </td>
                                                    <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px', textAlign: 'center', fontSize: '12px' }}>
                                                        {docline?.Quantity || 0}
                                                    </td>
                                                    <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px', textAlign: 'center', fontSize: '12px' }}>
                                                        {docline?.U_RML_ENTCLNDRO || '-'}
                                                    </td>
                                                    <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px', textAlign: 'center', fontSize: '12px' }}>
                                                        {docline?.U_RML_TIPO_CU || '-'}
                                                    </td>
                                                    <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px' }}></td>
                                                    <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px' }}></td>
                                                    <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px' }}></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    )}
                                </table>
                            </div>
                            <div style={{ backgroundColor: '#1D4ED8', color: 'white', padding: '8px', fontWeight: 'bold', marginTop: '6px', fontSize: '12px' }}>
                                CONTROL DE MOVIMIENTO DE CILINDROS
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px', padding: '10px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <label style={{ fontWeight: '600', whiteSpace: 'nowrap', fontSize: '12px' }}>Ingresa al cliente:</label>
                                    <div style={{ borderBottom: '1px solid #9CA3AF', flex: 1 }}></div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <label style={{ fontWeight: '600', whiteSpace: 'nowrap', fontSize: '12px' }}>Salida del cliente:</label>
                                    <div style={{ borderBottom: '1px solid #9CA3AF', flex: 1 }}></div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <label style={{ fontWeight: '600', whiteSpace: 'nowrap', fontSize: '12px' }}>Quedan cilindros en planta:</label>
                                    <div style={{ borderBottom: '1px solid #9CA3AF', flex: 1 }}></div>
                                </div>
                            </div>

                            <div style={{ overflowX: 'auto', marginBottom: '10px' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#DBEAFE' }}>
                                            <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px', fontWeight: '600' }} rowSpan="2">Detalle de cilindros</th>
                                            <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px', fontWeight: '600' }} colSpan="2">INGRESA EL CLIENTE</th>
                                            <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px', fontWeight: '600' }} colSpan="2">Salida del cliente</th>
                                            <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px', fontWeight: '600' }} rowSpan="2">Quedan cilindros en planta</th>
                                        </tr>
                                        <tr style={{ backgroundColor: '#DBEAFE' }}>
                                            <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px' }}>CONTEO DE SEGURIDAD</th>
                                            <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px' }}>CONTEO DE JEFE DE PLANTA</th>
                                            <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px' }}>CONTEO DE SEGURIDAD</th>
                                            <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px' }}>CONTEO DE JEFE DE PLANTA</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {['10K', '15K', '45K', '5K'].map((size) => (
                                            <tr key={size}>
                                                <td style={{ border: '1px solid #9CA3AF', padding: '8px', fontWeight: '600', backgroundColor: '#F3F4F6', fontSize: '12px' }}>CILINDRO {size}</td>
                                                <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px' }}></td>
                                                <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px' }}></td>
                                                <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px' }}></td>
                                                <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px' }}></td>
                                                <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px' }}></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div style={{ backgroundColor: '#1D4ED8', color: 'white', padding: '8px', fontWeight: 'bold', fontSize: '12px' }}>
                                OBSERVACIONES
                            </div>
                            <div style={{ padding: '10px' }}>
                                <div style={{ width: '100%', border: '1px solid #9CA3AF', padding: '8px', minHeight: '96px' }}></div>
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '32px' }}>
                                <div style={{ textAlign: 'center' }}>
                                    <div style={{ borderTop: '2px solid black', paddingTop: '8px', marginTop: '40px' }}>
                                        <p style={{ fontWeight: '600', margin: 0, fontSize: '12px' }}>Firma de jefe de planta</p>
                                    </div>
                                </div>
                                <div style={{ textAlign: 'center' }}>
                                    <div style={{ borderTop: '2px solid black', paddingTop: '8px', marginTop: '40px' }}>
                                        <p style={{ fontWeight: '600', margin: 0, fontSize: '12px' }}>Firma de seguridad</p>
                                    </div>
                                </div>
                                <div style={{ textAlign: 'center' }}>
                                    <div style={{ borderTop: '2px solid black', paddingTop: '8px', marginTop: '40px' }}>
                                        <p style={{ fontWeight: '600', margin: 0, fontSize: '12px' }}>Firma de cliente</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            )
        }

        if (DocHeader?.U_RS_TIPOV === 'ENVASA') {
            return (
                (DocLines.length + commentsLine) > linesForAllInOne && (
                    <>
                        <div className='mt-5' style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto" }}>
                            <div style={{ backgroundColor: 'white', padding: '10px' }}>
                                <div className='text-right mb-4' style={{ fontSize: "14px" }}>{(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio) + " - "}Página 1/
                                    {(DocLines.length > linesForAllInOne && linesfirstPage > DocLines.length) ?
                                        2
                                        :
                                        totalPages +
                                        1}
                                </div>
                                <div style={{ textAlign: 'center', padding: '10px' }}>
                                    <h1 style={{ fontSize: '30px', fontWeight: 'bold', color: '#1E3A8A', margin: 0 }}>ORDEN DE VENTA</h1>
                                    <span style={{ fontSize: '20px', color: '#4B5563' }}>Control de entrega y recepción de cilindros</span>
                                </div>
                                <div style={{ backgroundColor: '#1D4ED8', color: 'white', padding: '8px', fontWeight: 'bold' }}>
                                    DATOS DE LA ORDEN
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', padding: '10px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <label style={{ whiteSpace: 'nowrap' }}>Orden de venta N° (por sucursal / DocEntry):</label>
                                            <div style={{ borderBottom: '1px solid #9CA3AF', flex: 1, marginLeft: '8px' }}>{DocHeader?.DocNum} / {DocHeader?.DocEntry}</div>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <label style={{ whiteSpace: 'nowrap' }}>Fecha del documento:</label>
                                            <div style={{ borderBottom: '1px solid #9CA3AF', flex: 1, marginLeft: '8px' }}>{InfoByFolio?.docDate?.substring(0, 10)}</div>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <label style={{ whiteSpace: 'nowrap' }}>Unidad asignada:</label>
                                            <div style={{ borderBottom: '1px solid #9CA3AF', flex: 1, marginLeft: '8px' }}></div>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <label style={{ whiteSpace: 'nowrap' }}>Fecha de entrega:</label>
                                            <div style={{ borderBottom: '1px solid #9CA3AF', flex: 1, marginLeft: '8px' }}>{DocHeader?.DocDueDate?.substring(0, 10)}</div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ backgroundColor: '#1D4ED8', color: 'white', padding: '8px', fontWeight: 'bold' }}>
                                    DETALLE DE ARTÍCULOS
                                </div>
                                <div style={{ overflowX: 'auto' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#DBEAFE', borderTop: '2px solid #9CA3AF', borderBottom: '2px solid #9CA3AF' }}>
                                                <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '14px', fontWeight: '600' }}>Descripción de artículos</th>
                                                <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '14px', fontWeight: '600' }}>Cantidad</th>
                                                <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '14px', fontWeight: '600' }}>Entrega cilindros</th>
                                                <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '14px', fontWeight: '600' }}>Tipo de convenio</th>
                                                <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '14px', fontWeight: '600' }}>Cant. cilindros que entrega</th>
                                                <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '14px', fontWeight: '600' }}>Cant. cilindros físicos (en buenas condiciones)</th>
                                                <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '14px', fontWeight: '600' }}>Cantidad atendida</th>
                                            </tr>
                                        </thead>
                                        {DocLines && DocLines.length > 0 && (
                                            <tbody>
                                                {DocLines.slice(0, linesfirstPage).map((docline, index) => (
                                                    <tr key={docline.LineNum || index}>
                                                        <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px' }}>
                                                            {docline?.Dscription || '-'}
                                                        </td>
                                                        <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px', textAlign: 'center' }}>
                                                            {docline?.Quantity || 0}
                                                        </td>
                                                        <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px', textAlign: 'center' }}>
                                                            {docline?.U_RML_ENTCLNDRO || '-'}
                                                        </td>
                                                        <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px', textAlign: 'center' }}>
                                                            {docline?.U_RML_TIPO_CU || '-'}
                                                        </td>
                                                        <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px' }}></td>
                                                        <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px' }}></td>
                                                        <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px' }}></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        )}
                                    </table>
                                </div>
                                <div style={{ backgroundColor: '#1D4ED8', color: 'white', padding: '8px', fontWeight: 'bold', marginTop: '6px' }}>
                                    CONTROL DE MOVIMIENTO DE CILINDROS
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px', padding: '10px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <label style={{ fontWeight: '600', whiteSpace: 'nowrap' }}>Ingresa al cliente:</label>
                                        <div style={{ borderBottom: '1px solid #9CA3AF', flex: 1 }}></div>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <label style={{ fontWeight: '600', whiteSpace: 'nowrap' }}>Salida del cliente:</label>
                                        <div style={{ borderBottom: '1px solid #9CA3AF', flex: 1 }}></div>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <label style={{ fontWeight: '600', whiteSpace: 'nowrap' }}>Quedan cilindros en planta:</label>
                                        <div style={{ borderBottom: '1px solid #9CA3AF', flex: 1 }}></div>
                                    </div>
                                </div>
                                <div style={{ overflowX: 'auto', marginBottom: '10px' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#DBEAFE' }}>
                                                <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '14px', fontWeight: '600' }} rowSpan="2">Detalle de cilindros</th>
                                                <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '14px', fontWeight: '600' }} colSpan="2">INGRESA EL CLIENTE</th>
                                                <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '14px', fontWeight: '600' }} colSpan="2">Salida del cliente</th>
                                                <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '14px', fontWeight: '600' }} rowSpan="2">Quedan cilindros en planta</th>
                                            </tr>
                                            <tr style={{ backgroundColor: '#DBEAFE' }}>
                                                <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px' }}>CONTEO DE SEGURIDAD</th>
                                                <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px' }}>CONTEO DE JEFE DE PLANTA</th>
                                                <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px' }}>CONTEO DE SEGURIDAD</th>
                                                <th style={{ border: '1px solid #9CA3AF', padding: '8px', fontSize: '12px' }}>CONTEO DE JEFE DE PLANTA</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {['10K', '15K', '45K', '5K'].map((size) => (
                                                <tr key={size}>
                                                    <td style={{ border: '1px solid #9CA3AF', padding: '8px', fontWeight: '600', backgroundColor: '#F3F4F6' }}>CILINDRO {size}</td>
                                                    <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px' }}></td>
                                                    <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px' }}></td>
                                                    <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px' }}></td>
                                                    <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px' }}></td>
                                                    <td style={{ border: '1px solid #9CA3AF', padding: '8px', height: '25px' }}></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div style={{ backgroundColor: '#1D4ED8', color: 'white', padding: '8px', fontWeight: 'bold' }}>
                                    OBSERVACIONES
                                </div>
                                <div style={{ padding: '10px' }}>
                                    <div style={{ width: '100%', border: '1px solid #9CA3AF', padding: '8px', minHeight: '96px' }}></div>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '32px' }}>
                                    <div style={{ textAlign: 'center' }}>
                                        <div style={{ borderTop: '2px solid black', paddingTop: '8px', marginTop: '40px' }}>
                                            <p style={{ fontWeight: '600', margin: 0 }}>Firma de jefe de planta</p>
                                        </div>
                                    </div>
                                    <div style={{ textAlign: 'center' }}>
                                        <div style={{ borderTop: '2px solid black', paddingTop: '8px', marginTop: '40px' }}>
                                            <p style={{ fontWeight: '600', margin: 0 }}>Firma de seguridad</p>
                                        </div>
                                    </div>
                                    <div style={{ textAlign: 'center' }}>
                                        <div style={{ borderTop: '2px solid black', paddingTop: '8px', marginTop: '40px' }}>
                                            <p style={{ fontWeight: '600', margin: 0 }}>Firma de cliente</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {DocLines.length > linesfirstPage && (
                            <table>
                                <tr>
                                    <td>
                                        <div style={
                                            (DocLines.length > linesForAllInOne && remainingLines > 38 && remainingLines < linesfullPage) ? { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "7vw", marginBottom: "500px" }  : { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto" }}>
                                            {((remainingLines > 38 && remainingLines < linesfullPage) || (DocLines.length > linesForAllInOne && linesfirstPage > DocLines.length)) && (
                                                <table className='mt-5 mb-4' style={{ fontSize: "14px" }}>
                                                    <tbody>
                                                        <tr>
                                                            <td className='text-left'>{InfoByFolio.folio}</td>
                                                            <td className='text-right'>
                                                                {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio) + " - "}
                                                                Página {totalPages + 2}/{totalPages + 2}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        )}
                    </>
                )
            )
        }

        return (
            <>
            {/* Pedidos con 26 o menos articulos */}
                {(DocLines.length + commentsLine) <= linesForAllInOne &&
                    <table><tr><td>
                        <div>
                            <div className='mt-5' style={{height :"auto", width:"90%", marginLeft: "auto", marginRight:"auto", marginBottom: "100px"}}>
                                <div className='text-right mb-4' style={{ fontSize: "14px" }}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className='text-right'>
                                                    {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className='row'>
                                    <div className='col-8 text-right' />
                                    <div className='col-3 text-left' style={{ paddingLeft: "110px" }}>
                                        <h4><strong>Pedido</strong></h4>
                                        <span><strong>Fecha y Hora de emisión:</strong></span><br />
                                        <span>{moment(DocHeader.DocDate).format('YYYY-MM-DD') ?? ''} {DocHeader.DocTime.toString().substring(0,2)+":"+DocHeader.DocTime.toString().substring(2)?? ''}</span>
                                    </div>
                                    {!development &&
                                        <div className='col-1 text-right' style={{writingMode: 'vertical-lr', transform: 'rotate(180deg)'}}> 
                                            <span className='text-vertical pl-3 pr-1 pb-5' style={{ color: "white", background: "#ccc", fontSize: 20 }}><strong>{InfoByFolio.folio ?? ''}</strong></span>                                            
                                        </div>
                                    }
                                    {development &&
                                        // <div className='col-1 text-right'> {/*BORRADOR*/}                                           
                                        //     <img src={require('../../images/logo_draft.svg')} alt="Logo" />
                                        // </div>
                                        <div className='col-1 text-right' style={{writingMode: 'vertical-lr', transform: 'rotate(180deg)'}}> 
                                            <span className='text-vertical pl-3 pr-1 pb-5' style={{ color: "white", background: "#ccc", fontSize: 20 }}><strong>{InfoByFolio.folio ?? ''}</strong></span>                                            
                                        </div>
                                    }
                                </div>
                                <div className="row mt-5">
                                    <div className="col-4">
                                        <p>
                                            <strong>Cliente No</strong> {DocHeader.CardCode ?? ''} <br />
                                            {DocHeader.CardName ?? ''}<br />
                                            <strong>RUT:</strong> {DocHeader.LicTradNum ?? ''} <br />
                                            ENVIAR A:  {DocHeader.ShipDirection ?? ''}<br />
                                            {DocHeader.DocStatus === 'C' ? 'PAGADA' : 'PENDIENTE' ?? ''}
                                        </p>
                                    </div>
                                    <div className="col-4">
                                        <p>
                                            <strong>Ejemplo SA de CV</strong><br />
                                            RUT: {DocHeader.LicTradNum ?? ''}<br />
                                            {DocHeader.BillDirection ?? ''}
                                        </p>
                                    </div>
                                    <div className="col-4">
                                        <p>
                                            <strong>Vendedor:</strong> SIN ASIGNAR <br />
                                            <strong>Valida hasta: {moment(DocHeader.DocDueDate).format("YYYY-MM-DD") ?? ''}</strong>  <br />
                                            <strong>Correo : {DocHeader.E_Mail ?? ''}</strong>  <br />
                                            <strong>Teléfono: {DocHeader.Cellular ?? ''}</strong>  <br />
                                            <strong>Precios de contacto:</strong>
                                        </p>
                                    </div>
                                </div>
                                <div className='row mt-1' style={{ paddingRight: "15px", paddingLeft: "15px" }}>
                                    <label className="text-center" style={{fontSize: "14px"}}>{reprint?<><strong>REIMPRESION: </strong>{user.U_NAME} {time}</>:""}</label>
                                    <table>
                                        <thead style={{ borderTop: "solid 3px", borderBottom: "solid 3px" }}>
                                            <tr>
                                                <th className='pl-5'>Cantidad</th>
                                                <th>m2</th>
                                                <th>Descripción</th>
                                                <th>Descuento % </th>
                                                <th>Precio m2</th>
                                                <th>Precio</th>
                                                <th>Importe</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ borderBottom: "solid 3px" }}>
                                            {DocLines && DocLines.length > 0 &&
                                                DocLines.map((docline, index) => {
                                                    return (
                                                        <>
                                                        <tr>
                                                            <td className='pl-5'>{Number(docline.Quantity).toFixed(2) ?? ''}</td>
                                                            <td>0.00</td>
                                                            <td>{docline.Dscription ?? ''}</td>
                                                            <td>{Number(docline.DiscPrcnt).toFixed(2) ?? ''}</td>
                                                            <td>0.00</td>
                                                            <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(docline.Price) ?? ''}</td>
                                                            <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(docline.Quantity * docline.Price) ?? ''}</td>
                                                        </tr>
                                                        {docline.U_FMB_LineComment != ""?
                                                            <tr>
                                                                <td ></td>
                                                                <td colSpan={5}><strong>Comentario: </strong>{docline.U_FMB_LineComment}</td>
                                                            </tr>
                                                            :""
                                                        }
                                                        </>

                                                    );
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className='row mt-5'>
                                    <div className='col-7'>
                                        <p>
                                            <h5><strong>Referencia de pago:</strong><br /></h5>
                                            HSBC 12345678865 CLABE:1234532222 1964 BANAMEX 1234567 SUC. 7003<br />
                                            CLABE: 002760700318632698.<br />
                                            <br />
                                            <strong>Agradecemos sus comentarios y sugerencias en : hola@ejemplo.com.mx</strong><br/>
                                        </p>
                                    </div>
                                    <div className='col-2'></div>
                                    <div className='col-3'>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td><strong>Subtotal: </strong></td>
                                                    <td style={{ minWidth: "100px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal - DocHeader.VatSum) ?? ''}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Descuento: </strong></td>
                                                    <td>{ FORMAT_NUMBER.new(DocHeader.DiscPrcnt) ?? ''}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>IVA: </strong></td>
                                                    <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.VatSum) ?? ''}</td>
                                                </tr>
                                                {/* <tr>
                                                    <td><strong>Retención: </strong></td>
                                                    <td>{SYMBOL + FORMAT_NUMBER.new(DocHeader.VatSum) ?? ''}</td>
                                                </tr> */}
                                                <tr>
                                                    <td><strong>Total: </strong></td>
                                                    <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {DocHeader.Comments !== ""?
                                    <><strong>Comentarios: </strong>{DocHeader.Comments}</>
                                    :""
                                }
                                <h4 className={DocHeader.Comments !== ""?'mt-3':'mt-5'}><strong>Gracias por su preferencia</strong></h4>
                                <div className='row mt-3' style={{ background: "red", height: "10px", marginRight: "-3px", marginLeft: "-2px" }} ></div>
                                {/* <div className='row mt-3' style ={{height:'20px'}}></div> */}
                            </div>
                        </div>
                    </td></tr></table>
                }

            {/* Pedidos con mas de 26 articulos */}
                {(DocLines.length + commentsLine) > linesForAllInOne &&
                    <>  
                    {/* Primera hoja del pedido */}                      
                        <table><tr><td>
                            <div className='mt-5' style={{height :"auto", width:"90%", marginLeft: "auto", marginRight:"auto"}}>
                                <div className='text-right mb-4' style={{fontSize:"14px"}}>{(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio) + " - "}Pagina 1/
                                {(DocLines.length > linesForAllInOne && linesfirstPage > DocLines.length)?
                                    2
                                :
                                    totalPages+1
                                }
                                </div>
                                <div className='row'>
                                    <div className='col-8 text-right' />
                                    <div className='col-3 text-left' style={{ paddingLeft: "110px" }}>
                                        <h4><strong>Pedido</strong></h4>
                                        <span><strong>Fecha y Hora de emisión:</strong></span><br />
                                        <span>{moment(DocHeader.DocDate).format('YYYY-MM-DD') ?? ''} {moment(DocHeader.DocDate).format('LT') ?? ''}</span>
                                    </div>
                                    <div className='col-1 text-right' style={{ writingMode: 'vertical-lr', transform: 'rotate(180deg)' }}>
                                        <span className='text-vertical pl-3 pr-1 pb-5' style={{ color: "white", background: "#ccc", fontSize: 20 }}><strong>{InfoByFolio.folio ?? ''}</strong></span>
                                    </div>
                                </div>
                                <div className="row mt-5">
                                    <div className="col-4">
                                        <p>
                                            <strong>Cliente No</strong> {DocHeader.CardCode ?? ''} <br />
                                            {DocHeader.CardName ?? ''}<br />
                                            <strong>RUT:</strong> {DocHeader.LicTradNum ?? ''} <br />
                                            ENVIAR A:  {DocHeader.ShipDirection ?? ''}<br />
                                            {DocHeader.DocStatus === 'C' ? 'PAGADA' : 'PENDIENTE' ?? ''}
                                        </p>
                                    </div>
                                    <div className="col-4">
                                        <p>
                                            <strong>Ejemplo SA de CV</strong><br />
                                            RUT: {DocHeader.LicTradNum ?? ''}<br />
                                            {DocHeader.BillDirection ?? ''}
                                        </p>
                                    </div>
                                    <div className="col-4">
                                        <p>
                                            <strong>Vendedor:</strong> SIN ASIGNAR <br />
                                            <strong>Valida hasta: {DocHeader.DocDueDate ?? ''}</strong>  <br />
                                            <strong>Correo : {DocHeader.E_Mail ?? ''}</strong>  <br />
                                            <strong>Teléfono: {DocHeader.Cellular ?? ''}</strong>  <br />
                                            <strong>Precios de contacto:</strong>

                                        </p>
                                    </div>
                                </div>
                                <div className='row mt-1' style={{ paddingRight: "15px", paddingLeft: "15px" }}>
                                    <label className="text-center" style={{fontSize: "14px"}}>{reprint?<><strong>REIMPRESION: </strong>{user.U_NAME} {time}</>:""}</label>
                                    <table>
                                        <thead style={{ borderTop: "solid 3px", borderBottom: "solid 3px" }}>
                                            <tr>
                                                <th className='pl-5'>Cantidad</th>
                                                <th>m2</th>
                                                <th>Descripción</th>
                                                <th>Descuento % </th>
                                                <th>Precio m2</th>
                                                <th>Precio</th>
                                                <th>Importe</th>
                                            </tr>
                                        </thead>

                                        <tbody style={{ borderBottom: "solid 3px" }}>
                                            {DocLines && DocLines.length > 0 &&
                                                DocLines.map((docline, index) => {
                                                    if (countLines  <= linesfirstPage + countComments) {
                                                        countLines++
                                                        if (docline.U_FMB_LineComment != "") {
                                                            countComments++
                                                        }
                                                        return (
                                                            <>
                                                                <tr>
                                                                    <td className='pl-5'>{Number(docline.Quantity).toFixed(2) ?? ''}</td>
                                                                    <td>0.00</td>
                                                                    <td>{docline.Dscription ?? ''}</td>
                                                                    <td>{Number(docline.DiscPrcnt).toFixed(2) ?? ''}</td>
                                                                    <td>0.00</td>
                                                                    <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(docline.Price) ?? ''}</td>
                                                                    <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(docline.Quantity * docline.Price) ?? ''}</td>
                                                                </tr>
                                                                {docline.U_FMB_LineComment != ""?
                                                                    <tr>
                                                                        <td ></td>
                                                                        <td colSpan={5}><strong>Comentario: </strong>{docline.U_FMB_LineComment}</td>
                                                                    </tr>
                                                                    :""
                                                                }
                                                            </>
                                                        );
                                                    }else{
                                                        countLines++
                                                        return(<></>);
                                                    }
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </td></tr></table>

                    {/* Tablas extra de articulos */}
                        {DocLines.length  > linesfirstPage + countComments  && extraTables}
                        
                    {/* Total */}
                        <table><tr><td>
                            <div style={(DocLines.length > linesForAllInOne && remainingLines > 38 && remainingLines < linesfullPage )?
                                    {height :"auto", width:"90%", marginLeft: "auto", marginRight:"auto", marginTop: "7vw", marginBottom: "500px" }
                                :
                                    {height :"auto", width:"90%", marginLeft: "auto", marginRight:"auto"}
                            }>
                                
                            {((remainingLines > 38 && remainingLines< linesfullPage ) || (DocLines.length > linesForAllInOne && linesfirstPage > DocLines.length))&&
                                <table className='mt-5 mb-4' style={{fontSize:"14px"}}>
                                    <tbody>
                                        <tr>
                                            <td className='text-left'>
                                                {InfoByFolio.folio}
                                            </td>
                                            <td className='text-right'>
                                            {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio) + " - "}Pagina {totalPages+2}/{totalPages+2}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            }
                                
                                <div className='row mt-5'>
                                    <div className='col-7'>
                                        <p>
                                            <h5><strong>Referencia de pago:</strong><br /></h5>
                                            HSBC 12345678865 CLABE:1234532222 1964 BANAMEX 1234567 SUC. 7003<br />
                                            CLABE: 002760700318632698.<br />
                                            <br />
                                            <strong>Agradecemos sus comentarios y sugerencias en : hola@ejemplo.com.mx</strong><br />
                                        </p>
                                    </div>
                                    <div className='col-2'></div>
                                    <div className='col-3'>
                                        <table>

                                            <tbody>
                                                <tr>
                                                    <td><strong>Subtotal: </strong></td>
                                                    <td style={{ minWidth: "100px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal - DocHeader.VatSum) ?? ''}</td>
                                                </tr>
                                                {/* <tr>
                                                    <td><strong>Descuento: </strong></td>
                                                    <td>{ FORMAT_NUMBER.new(DocHeader.DiscPrcnt) ?? ''}</td>
                                                </tr> */}
                                                <tr>
                                                    <td><strong>IVA: </strong></td>
                                                    <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.VatSum) ?? ''}</td>
                                                </tr>
                                                {/* <tr>
                                                    <td><strong>Retención: </strong></td>
                                                    <td>{SYMBOL + FORMAT_NUMBER.new(DocHeader.VatSum) ?? ''}</td>
                                                </tr> */}
                                                <tr>
                                                    <td><strong>Total: </strong></td>
                                                    <td>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {DocHeader.Comments ??
                                    <strong>Comentarios: {DocHeader.Comments}</strong>
                                }
                                <h4 className={DocHeader.Comments !== ""?'mt-3':'mt-5'}><strong>Gracias por su preferencia</strong></h4>
                                <div className='row mt-3' style={{ background: "red", height: "10px", marginRight: "-3px", marginLeft: "-2px" }} ></div>
                                {/* <div className='row mt-3' style ={{height:'20px'}}></div> */}
                            </div>
                        </td></tr></table>
                    </>
                }
            </>
        )

    }

}

export default OrderDoc